import React, { useState } from 'react';
import { siteConfig } from '../assets/config';
import './Portfolio.css';

const Portfolio = () => {
  const [activeCategory, setActiveCategory] = useState('All');

  const portfolioProjects = [
    {
      id: 1,
      title: "Modern Villa Design",
      category: "Residential",
      description: "Contemporary villa with open floor plan and sustainable features",
      image: "🏠",
      year: "2023",
      area: "3,500 sq ft"
    },
    {
      id: 2,
      title: "Corporate Office Interior",
      category: "Commercial",
      description: "Modern office space with collaborative work areas",
      image: "🏢",
      year: "2023",
      area: "8,000 sq ft"
    },
    {
      id: 3,
      title: "Luxury Hotel Lobby",
      category: "Hospitality",
      description: "Elegant hotel lobby with premium finishes and lighting",
      image: "🏨",
      year: "2022",
      area: "2,500 sq ft"
    },
    {
      id: 4,
      title: "Minimalist Apartment",
      category: "Interior Design",
      description: "Clean and functional apartment design with smart storage",
      image: "🏡",
      year: "2023",
      area: "1,200 sq ft"
    },
    {
      id: 5,
      title: "Restaurant Interior",
      category: "Commercial",
      description: "Contemporary restaurant with warm ambiance and modern aesthetics",
      image: "🍽️",
      year: "2022",
      area: "3,000 sq ft"
    },
    {
      id: 6,
      title: "Family Home Renovation",
      category: "Residential",
      description: "Complete home renovation with modern amenities",
      image: "🏘️",
      year: "2023",
      area: "2,800 sq ft"
    },

          {
        id: 7,
        title: "Studio Apartment",
        category: "Interior Design",
        description: "Efficient studio design maximizing space and functionality",
        image: "🏠",
        year: "2023",
        area: "600 sq ft"
      }
  ];

  const filteredProjects = activeCategory === 'All' 
    ? portfolioProjects 
    : portfolioProjects.filter(project => project.category === activeCategory);

  return (
    <div className="portfolio-page">
      {/* Hero Section */}
      <section className="portfolio-hero">
        <div className="container">
          <div className="portfolio-hero-content">
            <h1>Our Portfolio</h1>
            <p>Showcasing our best work across various project types</p>
          </div>
        </div>
      </section>

      {/* Filter Section */}
      <section className="section filter-section">
        <div className="container">
          <div className="filter-buttons">
            {siteConfig.portfolioCategories.map((category) => (
              <button
                key={category}
                className={`filter-btn ${activeCategory === category ? 'active' : ''}`}
                onClick={() => setActiveCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Portfolio Grid */}
      <section className="section portfolio-grid-section">
        <div className="container">
          <div className="portfolio-grid">
            {filteredProjects.map((project) => (
              <div key={project.id} className="portfolio-item">
                <div className="portfolio-image">
                  <div className="image-placeholder">
                    <span>{project.image}</span>
                  </div>
                  <div className="portfolio-overlay">
                    <div className="overlay-content">
                      <h3>{project.title}</h3>
                      <p>{project.description}</p>
                      <div className="project-details">
                        <span>Year: {project.year}</span>
                        <span>Area: {project.area}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="portfolio-info">
                  <h3>{project.title}</h3>
                  <p className="project-category">{project.category}</p>
                  <p className="project-description">{project.description}</p>
                  <div className="project-meta">
                    <span>Year: {project.year}</span>
                    <span>Area: {project.area}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="section stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-number">20+</div>
              <div className="stat-label">Projects Completed</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">20+</div>
              <div className="stat-label">Happy Clients</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">4+</div>
              <div className="stat-label">Years Experience</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="container">
          <div className="cta-content text-center">
            <h2>Ready to Start Your Project?</h2>
            <p>Let's discuss how we can bring your vision to life</p>
                         <div className="cta-actions">
               <a href={`mailto:${siteConfig.contact.email}`} className="btn btn-primary">
                 Send Email
               </a>
             </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Portfolio; 